var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"size":"medium","readonly":"","type":"datetime","placeholder":"请选择时间"}})
}
var staticRenderFns = []

export { render, staticRenderFns }